export enum _ApiEndpoints {
  Login = '/login',
  PublicListing = '/recommendations/publicListings',
  ForgotPassowrd = '/UserAuthorization/forgot-password',
  SetNewPassword = '/UserAuthorization/reset-password-save',
  EmailRegister = '/UserAuthorization/email-register',
  TempRegister = '/UserAuthorization/temp-register',
  registerVerifyCode = '/UserAuthorization/registration-code-verify',
  resendVerificationCode = '/UserAuthorization/resend-verification-code',
  createAccount = '/UserAuthorization/registration',
  passowrdVerification = '/UserAuthorization/password-verification',
  contriesList = '/UserAuthorization/countries-list',
  contriesCitiesList = '/UserAuthorization/country-cities',
}

export enum ApiEndpoints {
  Login = 'auth/login',
  ForgetPassword = 'auth/init/forget-password',
  AuthMe = 'auth/me',
  PublicListing = '/recommendations/publicListings',
  ChangePassowrd = '/registeration/change-password',
  SetNewPassword = '/registeration/reset-password-save',
  EmailRegister = '/registeration/email-register',
  TempRegister = '/registeration/temp-register',
  registerVerifyCode = '/registeration/registration-code-verify',
  resendVerificationCode = '/registeration/resend-verification-code',
  createAccount = '/registeration/create-account',
  passowrdVerification = '/registeration/password-verification',
  contriesList = '/countries/list',
  contriesCitiesList = '/countries/cities',
  getCategories = 'category',
  getSubCategories = 'sub-category',
  getSections = 'section',
  getSectionFields = 'custom-fields',
  getTypes = 'types',
  duplicateSection = 'section/duplicate',
  duplicateField = 'custom-fields/duplicate',
  getUnitsMetrix = 'custom-fields/units',
  categoryOrder = 'category/order',
  subCategoriesOrder = 'sub-category/order',
  sectionsOrder = 'section/order',
  sectionFieldsOrder = 'custom-fields/order',
  typeOrder = 'types/order',
  getLanguage = 'settings/language',
  getStaticFields = 'sub-category/static',
  getDynamicFields = 'sub-category/fields',
  createNewVersion = 'version/new',
  checkNewActivity = 'version/activity',
  checkPublishVersion = 'version/activity/publish',
  allVersion = 'version',
  publishVersion = 'version/publish',
  getAddedDynamicFields = 'sub-category/fields/added',
  addStaticFields = '/sub-category/static/fields',
  getDivisionsCategory = 'divisions/category',
  divisions = 'divisions',
  tags = 'tags',
  inspectionSetting = 'divisions/setting',
  ruleField = 'custom-fields/rule',
  members = 'networks/members',
  networks = 'networks',
  networkConnectivity = 'network-connectivity',
  clusters = 'clusters',
  countries = 'utilities/countries',
  companyDomain = 'settings/company-domain',
  profileFields = 'profile-fields',
  //UserManagement
  user = 'user',
  allUser = 'user/all',
  permissions = 'permissions',
  userUtilsRoles = 'user/utils/roles',
  roles = 'roles',
  userRoles = 'user/role',
  userPermission = 'user/permission',
  userGlobalLogout = 'user/global-logout',
  forceRestart = 'force-reset-password',
  resetPassowrd = 'admin/change-password',

  //IMS-Inventory
  inventory = 'ims/inventory',
  inventoryFields = 'ims/inventory/fields',
  imsDivisions = '/ims/inventory/utils/divisions',
  imsCategories = '/ims/inventory/utils/categories',
  imsSubCategories = '/ims/inventory/utils/sub-categories',
  imsStatus = '/ims/inventory/utils/statuses',
  imsManufacturers = '/ims/inventory/utils/manufacturers',
  imsModels = '/ims/inventory/utils/models',
  imsTags = '/ims/inventory/utils/tags',
  imsCountries = '/ims/inventory/utils/countries',
  imsStates = '/ims/inventory/utils/states',
  imsCities = '/ims/inventory/utils/cities',
  imsClusters = '/ims/inventory/utils/clusters',
  imsCurrencies = '/ims/inventory/utils/currencies',
  //IMS-Discount
  discount = 'ims/discount',
  //Notification
  notification = 'notifications',
  unreadNotification = 'notifications/count',
  notificationReadAll = 'notifications/read/all',
  notificationRead = 'notifications/read',
  //Inspections-JobOrders
  getJobOrders = 'ins/jobs',
  getJobAssignee = 'ins/jobs/utility/assignee',
  getJobInventory = 'ins/jobs/utility/inventories',
  getJobCategories = 'ins/jobs/utility/categories',
  getJobWatchers = 'ins/jobs/utility/watchers',
  revertJob = 'ins/jobs/task',
  checkoutJob = 'ins/jobs/check-out',
  approveJob = 'ins/reports/approve',
  rejectJob = 'ins/reports/reject',
  taskDetail = 'ins/jobs/task',
  sendApprovalReminder = 'ins/reports/send-approval',
  reAssignTask = 'ins/jobs/task/reassign',
  cancelTask = 'ins/jobs/task/cancel',
  sendApprovalEmail = 'ins/reports/send-approval',
  getCoachAssignee = 'ins/jobs/utility/coach_assignee',

  //Inspections-Reports
  getAllReports = 'ins/reports',
  generateCombinedReport = 'ins/reports/combined',

  //Discrepancy Reports
  getAllDiscrepancyReports = 'ins/discrepancy',
  getCreateBtIdDiscrepancy = 'ins/discrepancy/utils/created-by',
  getDiscrepancyCategories = 'ins/discrepancy/utils/categories',
  getDiscrepancySubCategories = 'ins/discrepancy/utils/subcategories',
  getDiscrepancyInventory = 'ins/discrepancy/utils/inventories',
  getGenerateReports = 'ins/discrepancy/reports',
  getDiscrepancyFieldStatus = 'ins/discrepancy/utils/field-status',
  generateDiscrepanctReport = 'ins/discrepancy',
  getDiscrepancyReportDetails = 'ins/discrepancy',
  updateReportSummary = 'ins/discrepancy',
  getDiscrepancySeverity = 'ins/discrepancy/utils/severity',
  getDiscrepancyStatus = 'ins/discrepancy/utils/field-status',
  getReportsFields = 'ins/discrepancy/fields',
  deleteDiscrepancyFields = 'ins/discrepancy/fields',
  updateDiscrepancyFieldsSummary = 'ins/discrepancy/fields',
  deleteDiscrepancyFieldImage = 'ins/discrepancy/fields/image',

  //Template Management - Manage
  getAllTemplates = 'template',
  getTemplateCategories = 'template/utils/categories',
  getTemplateStatus = 'template/utils/status',
  getTemplateSubCategories = 'template/utils/sub-categories',
  deleteTemplate = 'template',
  updateTemplateDetails = 'template',
  duplicateTemplate = 'template/duplicate',
  getTemplateLogs = 'template/logs',
  getTemplatePreview = 'template',

  //CoachMode
  getGuestUser = 'ins/public/magic-link',
  getCoachChecklist = 'ins/jobs/checklist',
  submitReport = 'ins/reports',
  draftReport = 'ins/reports/draft',
  endSession = 'ins/jobs/cm/session/end',
  startSession = 'ins/jobs/cm/session/start',
  codeValidate = 'ins/public/magic-link/check/',
  completedReport = 'ins/reports/completed',
}
